export type NotifyException = (
    exception: Error,
    name?: string,
    metaData?: any,
    severity?: string
) => void;

export interface Bugsnag {
    notify: (eventName: string, errorMessage: string, metaData?: any, severity?: string) => void;
}
export interface BugsnagV2 extends Bugsnag {
    notifyException: NotifyException;
}
export interface BugsnagV3 extends Bugsnag {
    notifyException: NotifyException;
}
export interface BugsnagV4 extends Bugsnag {}

export const bugsnag = {
    notify: function(errorName: string, errorMessage: string, metaData?: any, severity?: string) {
        if (!window.Bugsnag) {
            return console.error(errorName, errorMessage, metaData); // eslint-disable-line no-console
        }
        window.Bugsnag.notify(errorName, errorMessage, metaData, severity);
    },
};
export default bugsnag;
